import React from "react";

const PodCorner = ({ style = {}, className = "", color = "#7EA5BB" }) => (
  <svg className={className} style={style}>
    <g fill="none" stroke={color} opacity=".29">
      <path d="M84.68 68l25.68 14.24v27.34l-25.68 14-25.68-14V82.24z" />
      <path d="M53.68 38l25.68 14.24v27.34l-25.68 14-25.68-14V52.24zM72.04 10l11.67 6.3v12.09l-11.67 6.2-11.68-6.2v-12.1zM38.68 1l14.68 8.09v15.54l-14.68 7.95L24 24.63V9.09z" />
      <path d="M23.68 28l14.68 8.09v15.54l-14.68 7.95L9 51.63V36.09zM82.68 35l14.68 8.09v15.54l-14.68 7.95L68 58.63V43.09zM8.82 5L17 9.5v8.65l-8.18 4.43-8.18-4.43V9.5z" />
    </g>
  </svg>
);

export default PodCorner;
